import type { Node as PMNode } from '@atlaskit/editor-prosemirror/model';
import type { BlockContent } from 'mdast';
import type { FromPMHandlers } from '../types';
import { convertBlockChildren } from '../utils';

export function blockquote(
	node: PMNode,
	handlers: FromPMHandlers,
): { children: BlockContent[]; type: 'blockquote' } {
	const children: BlockContent[] = convertBlockChildren(node, handlers);
	return { type: 'blockquote' as const, children };
}
